export enum SEARCH_BAR_GROUP {
  PRODUCTS = "products",
  CUSTOMERS = "customers",
}
